import React from 'react';
import {FormControlLabel, FormHelperText, FormControl, FormLabel} from '@mui/material/';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import {stylesRadio} from './styles'

export default function FormBotonRadio(props) {
    const classes = stylesRadio();

    return (
        <>
            {props.mostrarBotonRadio && (
                <FormControl className={classes.formControl} component="fieldset">
                    <FormLabel component="legend">{props.label}</FormLabel>
                    <RadioGroup
                        name={props.idelement}
                        value={props.value}
                        onChange={props.handleChangeRadio} className={classes.radioGroup}
                        >
                        {props.options?.map( ({value, label}) => (
                            <FormControlLabel
                                disabled={props.disabled}
                                key={value}
                                value={value}
                                control={<Radio />}
                                label={label}
                            />
                        ))
                        }
                    </RadioGroup>
                    {(props.isError) ? <FormHelperText className="Mui-error" id="component-error-text">{props.errorMessages}</FormHelperText> : null }
                </FormControl>
            )}
        </>
    )
}

FormBotonRadio.defaultProps = {
    mostrarBotonRadio: true
}